import styled, { css } from "styled-components";

interface HeaderProps {
    isDraggable?: boolean;
}

export const StyledHeaderWrapper = styled.div``;

export const StyledHeaderInnerWrapper = styled.div<HeaderProps>(
    ({ theme, isDraggable }) => css`
        background: ${theme.palette.common.white};
        font-family: ${theme.typography.base.main};
        display: grid;
        grid-template-columns: 40px 1fr auto;
        align-items: center;
        cursor: ${isDraggable ? "grab" : "default"};
        transition: background 0.2s ease, box-shadow 0.2s ease;

        ${isDraggable &&
        css`
            &:hover {
                background: ${theme.palette.common.lightGray};
                box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
            }
            &:active {
                cursor: grabbing;
            }
        `}
    `
);

export const StyledHeaderInfo = styled.div(
    () => css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        min-height: 40px;
        margin-left: 10px;
        margin-right: 10px;
    `
);

export const StyledHeaderMenu = styled.div(
    ({ theme }) => css`
        border-bottom: 1px solid ${theme.palette.common.lightGray};
    `
);

export const StyledUsername = styled.p(
    ({ theme }) => css`
        color: ${theme.palette.common.darkGray};
        font-family: ${theme.typography.base.main};
        font-size: 13px;
        font-weight: 400;
        margin: 10px 0 0 0;
        display: flex;
        align-items: center;
        gap: 8px;
    `
);

export const StyledTime = styled.small(
    ({ theme }) => css`
        color: ${theme.palette.common.gray};
        font-family: ${theme.typography.base.main};
        font-size: 12px;
    `
);

export const StyledQuestion = styled.h2(
    ({ theme }) => css`
        color: ${theme.palette.common.blue};
        font-family: ${theme.typography.base.main};
        font-size: 1rem;
        line-height: 1.35;
        font-weight: 400;
        text-align: left;
        margin: 0;

        &::first-letter {
            text-transform: uppercase;
        }
    `
);

export const StyledAvatarWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
    `
);

export const StyledQuestionRow = styled.div(
    () => css`
        display: inline-flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        margin-top: 0;
    `
);

export const StyledMultiVotingIcon = styled.span(
    ({ theme }) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 6px;
        background: linear-gradient(
            135deg,
            rgba(244, 3, 121, 0.1),
            rgba(34, 194, 252, 0.14)
        );
        color: ${theme.palette.common.tbBlue};
        border: 1px solid rgba(34, 194, 252, 0.24);
        transform: translateY(-1px);
    `
);
